<app-please-wait [hidden]="hidePleaseWait"></app-please-wait>

<div>
  <app-tabs #tabs class="mt-4">
    <app-tab
      [tabTitle]="i18n.basicInformation"
      tabId="basicInfo"
      (activeChange)="trackEventWhenActive($event, 'Essential information')">
      <input type="hidden" [(ngModel)]="_model.id" name="id" />
      <app-team-multi-selector
        containerClass="team-selector-standalone"
        [dispatches]="false"
        (OnTeamsChanged)="onTeamsChanged($event)"
        (OnTeamsInit)="OnTeamsInit()"
        [selector]="selector"
        [selectedIds]="selectedTeamIds">
      </app-team-multi-selector>
      <div class="w-full flex flex-col mt-4">
        <!-- Row 1 -->
        <div class="w-full flex flex-row gap-1 mb-3">
          <div class="w-2/6">
            <app-corporate-identity-input
              #corporateIdentityInput
              labelClass="table-label"
              [isNewClient]="isNewClient"
              [foreignCorporateIdentity]="_model.foreignCorporateIdentity"
              (foreignCorporateIdentityChange)="onForeignCorporateIdentityChange($event)"
              [(corporateIdentity)]="_model.corporateIdentity"
              (corporateIdentityChange)="onCorporateIdentyChange($event)"
              (buttonClick)="getCreditInformation()">
            </app-corporate-identity-input>
          </div>
          <div class="w-1/6">
            <bl-frontend-text-input
              id="customerNumber"
              (valueChange)="imDirty()"
              [(ngModel)]="_model.customerNumber"
              [text]="i18n.customerNumber"
              [maxlength]="20">
            </bl-frontend-text-input>
          </div>
          <div class="w-1/4 flex flex-col">
            <label class="table-label" for="responsible">{{ i18n.responsibleUser }}</label>
            <div
              *ngIf="hasPermissionToChange$ | async as hasPermissionToChange"
              [pTooltip]="!hasPermissionToChange.value && i18n.responsibleUserDisabledTooltipMessage"
              tooltipPosition="bottom"
              tooltipStyleClass="tooltip-extended-width"
              style="display: inline-block"
              class="w-full">
              <p-dropdown
                inputId="responsible"
                [options]="availableUsers$ | async"
                optionLabel="name"
                optionValue="id"
                [disabled]="!hasPermissionToChange.value"
                [(ngModel)]="_model.userId"
                (ngModelChange)="onResponsibleUserChanged($event)"
                styleClass="w-full"
                [autoOptionFocus]="false"
                [autoDisplayFirst]="false">
              </p-dropdown>
            </div>
          </div>
          <div class="w-1/4 flex flex-col">
            <label class="table-label" for="clientType">{{ i18n.companyType }}</label>
            <p-dropdown
              inputId="clientType"
              [options]="clientTypes$ | async"
              optionLabel="description"
              optionValue="name"
              [(ngModel)]="selectedType"
              (ngModelChange)="imDirty()"
              styleClass="w-full"
              [required]="true"
              [placeholder]="'constants.SELECT_WITH_HYPHENS' | transloco"
              [autoOptionFocus]="false"
              [autoDisplayFirst]="false">
            </p-dropdown>
          </div>
        </div>

        <!-- Row 2 -->
        <div class="w-full flex flex-row gap-2 mb-3">
          <div class="w-1/2">
            <bl-frontend-text-input
              id="clientName"
              required
              (valueChange)="imDirty()"
              [(ngModel)]="_model.name"
              [text]="i18n.name"
              [maxlength]="60" />
          </div>
          <div class="w-1/2 flex gap-2">
            <div class="w-1/2">
              <bl-frontend-text-input
                id="clientPhone"
                (valueChange)="imDirty()"
                [(ngModel)]="_model.phone"
                [text]="i18n.phone"
                [maxlength]="15">
              </bl-frontend-text-input>
            </div>
            <div class="w-1/2">
              <bl-frontend-text-input
                id="clientCellPhone"
                (valueChange)="imDirty()"
                [(ngModel)]="_model.cellphone"
                [text]="i18n.mobile"
                [maxlength]="15">
              </bl-frontend-text-input>
            </div>
          </div>
        </div>

        <!-- Row 3 -->
        <div class="w-full flex flex-row gap-2 mb-3">
          <div class="w-1/2">
            <bl-frontend-text-input
              id="clientAddress"
              (valueChange)="imDirty()"
              [(ngModel)]="_model.address"
              [text]="i18n.address"
              [maxlength]="60">
            </bl-frontend-text-input>
          </div>
          <div class="w-1/2">
            <!-- empty element to maintain layout -->
          </div>
        </div>

        <!-- Row 4 -->
        <div class="w-full flex flex-row gap-2 mb-3">
          <div class="w-1/2 flex gap-2">
            <div class="w-2/6">
              <bl-frontend-text-input
                id="clientZipCode"
                (valueChange)="imDirty()"
                [(ngModel)]="_model.zipCode"
                [text]="i18n.zipCode"
                [maxlength]="6">
              </bl-frontend-text-input>
            </div>
            <div class="w-4/6">
              <bl-frontend-text-input
                id="clientCity"
                (valueChange)="imDirty()"
                [(ngModel)]="_model.city"
                [text]="i18n.city"
                [maxlength]="60">
              </bl-frontend-text-input>
            </div>
          </div>
          <div class="w-1/2">
            <bl-frontend-text-input
              id="clientEmail"
              (valueChange)="imDirty()"
              [(ngModel)]="_model.email"
              [text]="i18n.email"
              [maxlength]="60">
            </bl-frontend-text-input>
          </div>
        </div>

        <!-- Row 5 -->
        <div class="w-full flex flex-row gap-2 mb-3">
          <div class="w-3/6">
            <bl-frontend-text-input
              id="clientCountry"
              (valueChange)="imDirty()"
              [(ngModel)]="_model.country"
              [text]="i18n.country"
              [maxlength]="60">
            </bl-frontend-text-input>
          </div>
          <div class="w-3/6">
            <bl-frontend-text-input
              id="clientWebPage"
              (valueChange)="imDirty()"
              [(ngModel)]="_model.webpage"
              [text]="i18n.webpage"
              [maxlength]="60">
            </bl-frontend-text-input>
          </div>
        </div>

        <!-- Row 6 -->
        <div class="w-full flex flex-row gap-2">
          <div class="w-3/6">
            <bl-frontend-text-input
              id="clientResidence"
              (valueChange)="imDirty()"
              [(ngModel)]="_model.residence"
              [text]="i18n.residence"
              [maxlength]="60">
            </bl-frontend-text-input>
          </div>
          <div class="w-3/6">
            <bl-frontend-text-input
              id="clientSignatory"
              (valueChange)="imDirty()"
              [(ngModel)]="_model.signatory"
              [text]="i18n.signatory"
              [maxlength]="60">
            </bl-frontend-text-input>
          </div>
        </div>
      </div>

      <div class="overflow-auto">
        <app-team-badges label="" [options]="teams" optionLabel="name" roundedClass="rounded-md"></app-team-badges>
      </div>

      <div class="flex justify-between items-end mt-14">
        <div class="grid grid-flow-col gap-3">
          <div>
            <bl-frontend-button
              [disabled]="!isPossibleToCreateCloudDb"
              [pTooltip]="isPossibleToCreateCloudDb && createCloudDbTooltip && createCloudDbTooltipContent"
              [tooltipOptions]="createCloudDbTooltipOptions"
              (onclick)="onCreateCloudDbClick()"
              [text]="createCloudDbButtonText$ | async">
            </bl-frontend-button>
            <ng-template #createCloudDbTooltipContent>
              <div class="font-semibold mb-3">{{ createCloudDbTooltip.title }}</div>
              <div [innerHTML]="createCloudDbTooltip.description | safeHtml"></div>
            </ng-template>
          </div>
          <!-- <div *appHideIfCountries="'NL'">
            <bl-frontend-button
              *ngIf="_model?.advisoryTool"
              variant="secondary"
              (onclick)="openGenerateAdvisoryReport()"
              [text]="i18n.advisoryReport">
            </bl-frontend-button>
            <bl-frontend-button
              *ngIf="!_model?.advisoryTool"
              variant="secondary"
              (onclick)="openActivateAdvisoryComponent()"
              [disabled]="!isPossibleToActivateAdvisoryTool"
              [text]="i18n.activateAdvisoryTool">
            </bl-frontend-button>
          </div> -->
          <div *appHideIfCountries="'NL'">
            <bl-frontend-button
              *ngIf="_model?.sustainabilityReporting"
              variant="secondary"
              (onclick)="gotoSustainabilityReporting()"
              [disabled]="!config.data.firm.sustainabilityReporting"
              [text]="i18n.openSusainabilityReporting">
            </bl-frontend-button>
            <bl-frontend-tooltip
              [content]="info?.tooltip"
              *ngIf="!_model?.sustainabilityReporting && (activateOrDeactivateSustainabilityReportingInfo | async) as info">
              <bl-frontend-button
                variant="secondary"
                (onclick)="showActivateSustainabilityReportingDialog()"
                [disabled]="!info?.canActivate"
                tooltipPosition="top"
                [text]="i18n.activateSustainabilityReporting">
              </bl-frontend-button>
            </bl-frontend-tooltip>
          </div>
        </div>
      </div>
      <div class="flex justify-between items-end -mx-5 -mb-7 mt-6 p-4 bg-bl-grey-100">
        <div>
          <bl-frontend-button
            class="mr-3"
            (onclick)="saveClientAndUpdateCloud()"
            [disabled]="!isPossibleToUpdateCloudCompany"
            [title]="i18n.saveAndUpdateCloudCompany"
            [text]="i18n.saveAndUpdate"></bl-frontend-button>
        </div>
        <div>
          <bl-frontend-button
            variant="secondary"
            (onclick)="closeDialog()"
            class="mr-3"
            [text]="'shared.close' | transloco">
          </bl-frontend-button>

          <bl-frontend-button
            [disabled]="_model.archived || !_model.name || !selectedType"
            [title]="i18n.saveOnlyInFirmSupport"
            (onclick)="addClient()"
            [text]="'shared.save' | transloco">
          </bl-frontend-button>
        </div>
      </div>
    </app-tab>
    <app-tab
      [tabTitle]="i18n.businessDetails"
      tabId="businessDetails"
      (activeChange)="trackEventWhenActive($event, 'Business details')">
      <app-client-business-detail
        [client]="_model"
        (detailsEmitter)="harvestDetails($event)"
        (dirtyEmitter)="isDirty($event)">
      </app-client-business-detail>
    </app-tab>
    <app-tab
      [tabTitle]="i18n.financialYears"
      [disabled]="isNewClient"
      tabId="financialYears"
      (activeChange)="trackEventWhenActive($event, 'Financial years')">
      <app-client-financialyears
        [client]="_model"
        [defaultFinancialYear]="creditInformationDefaultFinancialYears"
        (update)="onFinancialYearUpdated($event)">
      </app-client-financialyears>
    </app-tab>
    <app-tab
      [tabTitle]="i18n.assignments"
      [disabled]="isNewClient"
      *appHideIfCountries="'NL'"
      tabId="assignments"
      (activeChange)="trackEventWhenActive($event, 'Assignments')">
      <app-client-assignments [client]="_model" (updateEmitter)="callForUpdate($event)"></app-client-assignments>
    </app-tab>
    <app-tab
      [tabTitle]="i18n.contacts"
      [disabled]="isNewClient"
      tabId="contacts"
      (activeChange)="trackEventWhenActive($event, 'Contacts')">
      <app-client-contacts [client]="_model"></app-client-contacts>
    </app-tab>
    <app-tab
      [tabTitle]="i18n.documents"
      [disabled]="isNewClient"
      [(active)]="documentTabActive"
      *appHideIfCountries="'NL'"
      tabId="documents"
      (activeChange)="trackEventWhenActive($event, 'Documents')">
      <app-file-browser [client]="_model" [active]="documentTabActive"></app-file-browser>
    </app-tab>
    <app-tab
      [tabTitle]="i18n.notes"
      [disabled]="isNewClient"
      tabId="todos"
      (activeChange)="trackEventWhenActive($event, 'Notes')">
      <app-client-todos [client]="_model"></app-client-todos>
    </app-tab>
    <app-tab
      [tabTitle]="i18n.cloudServices"
      [disabled]="isNewClient"
      [(active)]="cloudServiceTabActive"
      tabId="cloudServices"
      (activeChange)="trackEventWhenActive($event, 'Settings')">
      <app-client-cloud-service
        [client]="_model"
        [active]="cloudServiceTabActive"
        (updated)="onClientUpdatedInCloudServiceTab($event)"
        (updatedWithoutSave)="onClientUpdatedInCloudServiceTab($event, false)">
      </app-client-cloud-service>
    </app-tab>
    <app-tab
      [tabTitle]="i18n.subscription"
      [tabTooltip]="subscriptionTabTooltip"
      [disabled]="isNewClient || isPersonCompanyType || isOnlyWorkflowFirm"
      [(active)]="lundifyTabActive"
      tabId="lundify">
      <app-lundify-subscription [client]="toClientType(_model)" [active]="lundifyTabActive"></app-lundify-subscription>
    </app-tab>
    <app-tab
      [tabTitle]="i18n.aml"
      [disabled]="isNewClient"
      [(active)]="amlTabActive"
      tabId="aml"
      (activeChange)="trackEventWhenActive($event, 'AML')">
      <app-client-aml [client]="_model" [active]="amlTabActive"></app-client-aml>
    </app-tab>
  </app-tabs>
  <!-- <a href="#" id="gotoBlapp" target="_blank"></a> -->
</div>
